import React, { FC } from "react";
import { IPaymentType, PaymentType } from "../../../../../scripts/models/Payment";
import Category from "../../../../../scripts/models/Category";
import { CompanyContext } from "../../../../../scripts/context/CompanyContext";
import { KontoContext } from "../../../../../scripts/context/accountingData/KontoEntitiesProvider";

type Props = {
    paymentType: IPaymentType;
    year: number;
};
export const PaymentTypeOption: FC<Props> = ({ paymentType: type, year }) => {
    const { companyGQL } = React.use(CompanyContext);
    const { categoryOverridesAllMap } = React.use(KontoContext);
    if (!type) {
        return "";
    }
    const accountingYearConfig = companyGQL.accountingConfigs.find(v => v.year === year);
    console.log(companyGQL);
    console.log(year);
    switch (type.value) {
        case PaymentType.OptionPayment:
            return "Zahlung";
        case PaymentType.OptionVerrechnung:
            return "Verrechnung mit geleisteten Anzahlungen";
    }

    const paymentKontoCategory = new Category(type.konto, "");
    if (type.value === PaymentType.OptionKasse) {
        const kb = companyGQL.kasseList
            .filter(v => v.year === year)
            .find(v => new Category(v.accountNum.toString(), "").equalsTo(paymentKontoCategory));
        if (!kb || !accountingYearConfig) {
            return "Kasse " + paymentKontoCategory.getExtNumPrint(accountingYearConfig.kontoExt);
        }
        const cat = new Category(String(kb.accountNum), kb.name);
        return (
            <>
                {cat.getExtNumPrint(accountingYearConfig.kontoExt)} - {cat.name}
            </>
        );
    }

    if (type.value === PaymentType.OptionBank) {
        const bank = companyGQL.bankList
            .filter(v => v.year === year)
            .find(v => new Category(v.accountNum.toString(), "").equalsTo(paymentKontoCategory));
        if (!bank || !accountingYearConfig) {
            return "Bank " + paymentKontoCategory.getExtNumPrint(accountingYearConfig.kontoExt);
        }
        const cat = new Category(String(bank.accountNum), bank.name);
        return cat.getExtNumPrint(accountingYearConfig.kontoExt) + " - " + cat.name;
    }

    const num = new Category(type.konto, "").getExtNumPrint(accountingYearConfig.kontoExt);
    const name = categoryOverridesAllMap
        .get(String(year))
        ?.find(v => new Category(v.num, "").equalsTo(paymentKontoCategory))?.name;

    return (
        <>
            {num} - {name}
        </>
    );
};
